<template>
  <v-btn
    variant="text"
    class="main-nav-btn mx-1"
    size="small"
    v-bind="$attrs"
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
  name: 'BaseMainNavBtn',

  inheritAttrs: false,
};
</script>
